export const materials = {
  data () {
    return {}
  },
  methods: {
    dodanie_materialow (akumulatory, zasilacz) {
      var glebokosc = this.inputs.glebokosc_szafy.value
      var iloscWzmacniaczy = this.inputs.wzmacniacz.value
      var iloscWzmacniaczyRezerwowych = this.inputs.wzmacniacz_rezerwowy.value
      var iloscKontrolerow = this.inputs.kontroler.value
      var iloscRouterow = this.inputs.router.value
      var iloscMikrofonow = this.inputs.wariant1.value
      var iloscWentylatorow = this.inputs.panel_wentylacyjny.value

      Object.values(this.ListaMaterialy).forEach(element => {
        element.sztuk = 0
      })

      if (glebokosc === 600 || glebokosc === '600') {
        if (akumulatory.polki === 1 || akumulatory.polki === '1') {
          this.ListaMaterialy['POZ172PM'].sztuk += 1
          this.ListaMaterialy['MC454'].sztuk += (8 + 16)
          this.ListaMaterialy['POZ172WM'].sztuk += 2
          this.ListaMaterialy['ML473'].sztuk += 4
          this.ListaMaterialy['ML499'].sztuk += 4
        } else {
          this.ListaMaterialy['POZ172PM'].sztuk += 2
          this.ListaMaterialy['MC454'].sztuk += ((8 * 2) + 16)
          this.ListaMaterialy['POZ172WM'].sztuk += 2
          this.ListaMaterialy['ML473'].sztuk += 8
          this.ListaMaterialy['ML499'].sztuk += 8
        }
      } else {
        if (akumulatory.polki === 1 || akumulatory.polki === '1') {
          this.ListaMaterialy['POZ172PD'].sztuk += 1
          this.ListaMaterialy['MC454'].sztuk += (8 + 16)
          this.ListaMaterialy['POZ172WD'].sztuk += 2
          this.ListaMaterialy['ML473'].sztuk += 4
          this.ListaMaterialy['ML499'].sztuk += 4
        } else {
          this.ListaMaterialy['POZ172PD'].sztuk += 2
          this.ListaMaterialy['MC454'].sztuk += ((8 * 2) + 16)
          this.ListaMaterialy['POZ172WD'].sztuk += 2
          this.ListaMaterialy['ML473'].sztuk += 8
          this.ListaMaterialy['ML499'].sztuk += 8
        }
      }

      if (iloscWzmacniaczy !== 0 || iloscWzmacniaczy !== '0') {
        if (glebokosc === 600 || glebokosc === '600') {
          this.ListaMaterialy['POZ172WM'].sztuk += 2 * iloscWzmacniaczy
        } else {
          this.ListaMaterialy['POZ172WD'].sztuk += 2 * iloscWzmacniaczy
        }
        this.ListaMaterialy['PKAZ150'].sztuk += 1 * iloscWzmacniaczy
        this.ListaMaterialy['MC454'].sztuk += 10 * iloscWzmacniaczy
        this.ListaMaterialy['ML518'].sztuk += 1 * iloscWzmacniaczy
        this.ListaMaterialy['ML519'].sztuk += 4 * iloscWzmacniaczy
      }

      if (iloscWzmacniaczyRezerwowych !== 0 || iloscWzmacniaczyRezerwowych !== '0') {
        if (glebokosc === 600 || glebokosc === '600') {
          this.ListaMaterialy['POZ172WM'].sztuk += 2 * iloscWzmacniaczyRezerwowych
        } else {
          this.ListaMaterialy['POZ172WD'].sztuk += 2 * iloscWzmacniaczyRezerwowych
        }
        this.ListaMaterialy['PKAZ150'].sztuk += 1 * iloscWzmacniaczyRezerwowych
        this.ListaMaterialy['MC454'].sztuk += 10 * iloscWzmacniaczyRezerwowych
        this.ListaMaterialy['ML518'].sztuk += 1 * iloscWzmacniaczyRezerwowych
        this.ListaMaterialy['ML519'].sztuk += 4 * iloscWzmacniaczyRezerwowych
      }

      if (iloscKontrolerow === 1 || iloscKontrolerow === '1') {
        if (glebokosc === 600 || glebokosc === '600') {
          this.ListaMaterialy['POZ172WM'].sztuk += 2 * iloscKontrolerow
        } else {
          this.ListaMaterialy['POZ172WD'].sztuk += 2 * iloscKontrolerow
        }
        this.ListaMaterialy['PKAZ150'].sztuk += 1 * iloscKontrolerow
        this.ListaMaterialy['MC454'].sztuk += 10 * iloscKontrolerow
        this.ListaMaterialy['ML518'].sztuk += 1 * iloscKontrolerow
        this.ListaMaterialy['ML475'].sztuk += 4 * iloscKontrolerow
      }

      if (iloscRouterow !== 0 || iloscRouterow !== '0') {
        if (glebokosc === 600 || glebokosc === '600') {
          this.ListaMaterialy['POZ172WM'].sztuk += 2 * iloscRouterow
        } else {
          this.ListaMaterialy['POZ172WD'].sztuk += 2 * iloscRouterow
        }
        this.ListaMaterialy['PKAZ150'].sztuk += 1 * iloscRouterow
        this.ListaMaterialy['MC454'].sztuk += 10 * iloscRouterow
        this.ListaMaterialy['ML518'].sztuk += 1 * iloscRouterow
        this.ListaMaterialy['ML475'].sztuk += 4 * iloscRouterow
      }

      if (iloscMikrofonow !== 0 || iloscMikrofonow !== '0') {
        this.ListaMaterialy['RAPW600'].sztuk += 1 * iloscMikrofonow
        this.ListaMaterialy['MC454'].sztuk += 4 * iloscMikrofonow
      }

      // panel sygnalizacyjny zamontowany zawsze w stalych
      this.ListaMaterialy['MC454'].sztuk += 2

      if (iloscWentylatorow !== 0 || iloscWentylatorow !== '0') {
        this.ListaMaterialy['MC454'].sztuk += 6
        // tab_wyrob[8].sztuk += 6 * ilosc_wentyl_w_szafie; // komplet montażowy
        this.ListaMaterialy['ML486'].sztuk += 1
        this.ListaMaterialy['ML485'].sztuk += 5
        // tab_wyrob[17].sztuk += 1 // ML486
        // tab_wyrob[23].sztuk += 5 // ML485
      } else {
        // this.ListaMaterialy['ML474'].sztuk += 8;
        // tab_wyrob[16].sztuk += 8 // ML474
      }

      if (zasilacz.attributes.wyjscia === 5 || zasilacz.attributes.wyjscia === '5') {
        this.ListaMaterialy['ML479'].sztuk += 6
        // tab_wyrob[18].sztuk += 6; //ML479 – 6szt dla zasilacza 5 WYJŚĆ
      } else {
        this.ListaMaterialy['ML479'].sztuk += 10
        // tab_wyrob[18].sztuk += 10; //ML479 – 10szt dla zasilacza 9 WYJŚĆ
      }

      this.ListaMaterialy['MRAKD1'].sztuk += 1
      this.ListaMaterialy['DSOKAB'].sztuk += 1
      this.ListaMaterialy['ML474'].sztuk += 8
      this.ListaMaterialy['ML090'].sztuk += 1
      this.ListaMaterialy['MR014'].sztuk += 1
      this.ListaMaterialy['MD012'].sztuk += 1
      this.ListaMaterialy['MD013'].sztuk += 1

      var cenaPW = 0
      var wagaPW = 0

      Object.values(this.ListaMaterialy).forEach(element => {
        // console.log(element.kod, element.attributes.waga, element.attributes.cena, element.sztuk)
        cenaPW += (Number(element.attributes.cena) * element.sztuk)
        wagaPW += (Number(element.attributes.waga) * element.sztuk)
      })

      return {'cena': cenaPW, 'waga': wagaPW}
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/materials.js